import React, { useContext } from "react";
import BaseList from "../../components/BaseList";
import Toggle from "../../components/DataGrid/toggle.js";
import { Context } from "../../Reducers/Store";

const getColumns = ({ podeEditar, navigate, baseRoute, onToggleStatus, isSistema }) => {
  const columns = [
    { field: "nome", header: "Nome", sortable: true },
    { field: "email", header: "E-mail", sortable: true },
  ];

  if (isSistema) {
    columns.push({
      field: "contaNome",
      header: "Conta",
      render: (row) => (
        <span className={row.contaNome !== "Sistema" ? "text-gray-800" : "text-purple-600 font-medium"}>
          {row.contaNome}
        </span>
      ),
    });
  }

  columns.push({
    key: "tipoUsuario",
    header: "Tipo",
    className: "text-center",
    headerClassName: "text-center",
    width: "120px",
    render: (row) => {
      const tipos = {
        1: { label: "Sistema", className: "bg-purple-100 text-purple-700" },
        2: { label: "Admin", className: "bg-blue-100 text-blue-700" },
        3: { label: "Usuário", className: "bg-gray-100 text-gray-700" },
      };
      const tipo = tipos[row.tipoUsuario] || tipos[3];
      return (
        <span className={`px-2 py-1 text-xs font-medium rounded-full ${tipo.className}`}>
          {tipo.label}
        </span>
      );
    },
  });

  columns.push({
    key: "ativo",
    header: "Ativo",
    className: "text-center",
    headerClassName: "text-center",
    width: "100px",
    render: (row) => (
      <div onClick={(e) => e.stopPropagation()}>
        <Toggle
          value={row.ativo}
          onChange={() => onToggleStatus(row.id, row.ativo)}
          disabled={!podeEditar}
        />
      </div>
    ),
  });

  if (podeEditar) {
    columns.push({
      key: "acoes",
      header: "Ações",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${baseRoute}/${row.id}`);
          }}
          className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
          title="Editar"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>
      ),
    });
  }

  return columns;
};

export default function UsuarioList() {
  const [state] = useContext(Context);
  const isSistema = state?.profile?.tipo_usuario === "Sistema";

  return (
    <BaseList
      titulo="Usuários do Sistema"
      endpoint="usuario"
      baseRoute="/usuarios"
      getColumns={(props) => getColumns({ ...props, isSistema })}
      permissoes={{
        criar: "usuarios.criar",
        editar: "usuarios.editar",
        remover: "usuarios.remover",
      }}
      emptyMessage="Nenhum usuário encontrado"
      novoButtonText="Novo Usuário"
      emptyButtonText="Cadastrar primeiro usuário"
    />
  );
}